export const parseQueryParams = (search = '') => {
  const query = search[0] === '?'
    ? search.slice(1)
    : search

  return query
    .split('&')
    .map((kvPair) => kvPair.split('='))
    .reduce((params, [key, value]) => {
      params[key] = value
      return params
    }, {})
}
